import React, { useState } from "react";
import { CLOSE_ICON } from "../../../utills/image-constant";
import html2canvas from "html2canvas";
import PptxGenJS from 'pptxgenjs';
import jsPDF from "jspdf";
const GraphDownloadModel = ({
  modalBody,
  buttonLable = "",
  modalClick,
  modalClose,
  modalimg = "",
  title = "",
  msg = "",
  onAddItem = '',
  children,
  heading = "",
  className = '',
  currentGraph = '',
  handleClick = function o() { },
}) => {

  const [exportloading, setExportLoading] = useState();
  const [currentGraphActive, setCurrentGraphActive] = useState(false);

  const handleExportPDF = (value) => {
    setCurrentGraphActive(true);
    setExportLoading(0);

    // Hide elements before exporting
    document.querySelectorAll(".hide-in-pdf").forEach((el) => {
      el.style.visibility = "hidden";
    });

    requestAnimationFrame(async () => {
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth() - 10;
      const chartElement = document.querySelector(`.${value}`);

      if (!chartElement) {
        console.error("Element not found:", value);
        setCurrentGraphActive(false);
        return;
      }

      try {
        setExportLoading(40);
        const canvas = await html2canvas(chartElement, { scale: 1.5 });
        setExportLoading(60);
        const imgData = canvas.toDataURL("image/png");
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        const heading = chartElement.getAttribute("data-heading");
        const remark = chartElement.getAttribute("data-remark");

        if (heading) {
          pdf.setFontSize(16);
          pdf.text(heading, 5, 10);
        }

        let yPosition = 18; // Initial y position after heading
        if (remark) {
          pdf.setFontSize(12);
          pdf.setTextColor(255, 0, 0);

          // Split text into multiple lines if too long
          let maxWidth = pdf.internal.pageSize.width - 10; // Adjust max width to avoid text overflow
          let remarkLines = pdf.splitTextToSize("Remark -: " + remark, maxWidth);

          // Print the remark text with dynamic height adjustment
          pdf.text(remarkLines, 5, yPosition);
          yPosition += remarkLines.length * 6; // Adjust Y position based on text height
        }

        setExportLoading(80);
        pdf.addImage(imgData, "PNG", 5, yPosition + 5, pdfWidth, pdfHeight);

        document.querySelectorAll(".hide-in-pdf").forEach((el) => {
          el.style.visibility = "visible";
        });


        setExportLoading(100);
        pdf.save(`${value}.pdf`);
      } catch (error) {
        console.error("Error processing chart:", error);
      } finally {
        setCurrentGraphActive(false);
        setTimeout(() => {
          setExportLoading();
        }, 2000);
      }
    });
  };


  const handleExportPNG = async (value) => {
    setCurrentGraphActive(true);
    setExportLoading(0);

    const element = document.querySelector(`.${value}`);
    if (!element) {
      console.error("Element not found");
      setCurrentGraphActive(false);
      return;
    }

    document.querySelectorAll(".hide-in-pdf").forEach((el) => {
      el.style.display = "none";
    });

    try {
      setExportLoading(50);

      // Ensure the UI updates before capturing the screenshot
      await new Promise((resolve) => requestAnimationFrame(resolve));

      const canvas = await html2canvas(element, { scale: 2 });

      setExportLoading(75);
      await new Promise((resolve) => requestAnimationFrame(resolve));

      const imgData = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = imgData;
      link.download = `image_${value}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setExportLoading(100);
      document.querySelectorAll(".hide-in-pdf").forEach((el) => {
        el.style.display = "block";
      });
    } catch (error) {
      console.error("Error processing image download:", error);
      setCurrentGraphActive(false);
    } finally {
      setTimeout(() => {
        setExportLoading();
      }, 2000);
      setCurrentGraphActive(false);
    }
  };


  return (

    <div className="emp-model">
      <button
        type="button"
        class="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop"
        ref={modalClick}
      >
      </button>

      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {

            modalClose && modalClose();
          }
        }}
      >
        <div className={`modal-dialog modal-dialog-centered ${className}`}>
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="btn btnclose"
                data-bs-dismiss="modal"
                aria-label="Close"
                disabled={currentGraphActive}
              >
                <img onClick={modalClose} src={CLOSE_ICON} alt="close"></img>
              </button>
              <h5 class="modal-title" id="staticBackdropLabel">
                {title}
              </h5>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-md-12">
                  {exportloading >= 0 && (
                    <>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: `${exportloading}%` }}
                          role="progressbar"
                          aria-valuenow={exportloading}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </>
                  )}
                  {exportloading < 99.9 && (
                    <p className="text-success">Waiting For download....</p>
                  )}
                  {exportloading == 100 && (
                    <p className="text-success">Thankyou for downloading.</p>
                  )}

                  <br />
                  <br />
                  <div className="d-flex align-items-center justify-content-center resulticon_content">
                    <button disabled={currentGraphActive} className="exportpdfbtn cursor-pointer me-3" onClick={() => handleExportPDF(currentGraph)}>
                      Export PDF
                    </button>
                    {/* <button disabled={currentGraphActive} onClick={() => handleExportPPT(currentGraph)} className="exportpdfbtn cursor-pointer me-3">
                      Export PPT
                    </button> */}
                    <button disabled={currentGraphActive} onClick={() => handleExportPNG(currentGraph)} className="exportpdfbtn cursor-pointer">
                      Export Image
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraphDownloadModel;
